import { render, staticRenderFns } from "./snSessionTimeout.vue?vue&type=template&id=3b264d67&"
import script from "./snSessionTimeout.vue?vue&type=script&lang=js&"
export * from "./snSessionTimeout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports